/* RESPONSIBLE TEAM: team-standalone */

import Service from '@ember/service';
// @ts-ignore
import { dedupeTracked } from 'tracked-toolbox';
export default class CopilotFrameService extends Service {
  @dedupeTracked composerHasContent = false;
}

declare module '@ember/service' {
  interface Registry {
    copilotFrameService: CopilotFrameService;
    'copilot-frame-service': CopilotFrameService;
  }
}
